import { Translations } from "@/plugins/i18n";
import Route from "../router/Route";

/**
 * Module class that provides different set of grouped routes
 * with their own permissions and translations.
 */
export default class Module {
	constructor(
		public baseRoute: Route,
		public translations: Translations,
		public permissions: string[]
	) {}

	public hasPermissions(permissions: string[]): boolean {
		if (permissions.length === 0) return true;

		return (
			this.permissions.filter((modulePermission) =>
				permissions.includes(modulePermission)
			).length > 0
		);
	}
}
